import React from 'react';
import { Star, Quote } from 'lucide-react';
interface TestimonialProps {
  name: string;
  age: number;
  city: string;
  quote: string;
}
export function TestimonialCard({
  name,
  age,
  city,
  quote
}: TestimonialProps) {
  return <div className="bg-white p-6 rounded-xl shadow-md border border-gray-100 flex flex-col h-full relative" data-id="element-251">
      <Quote className="absolute top-4 right-4 w-8 h-8 text-orange-100" data-id="element-252" />

      <div className="flex items-center gap-1 mb-4" data-id="element-253">
        {[...Array(5)].map((_, i) => <Star key={i} className="w-4 h-4 fill-yellow-400 text-yellow-400" data-id="element-254" />)}
      </div>

      <p className="text-gray-700 italic mb-6 flex-grow relative z-10" data-id="element-255">
        "{quote}"
      </p>

      <div className="flex items-center gap-3 mt-auto border-t pt-4 border-gray-100" data-id="element-256">
        <div className="w-10 h-10 bg-gray-200 rounded-full flex items-center justify-center text-gray-500 font-bold text-sm" data-id="element-257">
          {name.charAt(0)}
        </div>
        <div data-id="element-258">
          <p className="font-bold text-gray-900 text-sm" data-id="element-259">{name}</p>
          <p className="text-xs text-gray-500" data-id="element-260">
            {age} años, {city}
          </p>
        </div>
      </div>
    </div>;
}